import type { StyleProps } from "@ui/types";

export const styles = {
    wrapper: {
        display: "flex",
        flexDirection: "column",
        paddingTop: 2,
        width: "100%",
        minHeight: "332px",
        justifyContent: "space-between",
    },
    headerBox: {
        textAlign: "left",
        fontWeight: "bold",
    },
    headerFadeBox: {
        color: "white",
        textTransform: "uppercase",
        fontWeight: "bold",
    },
    headerSuccessBox: {
        py: [2, 2, 2, 2],
        mt: [7, 7],
    },
    headerSuccessFadeBox: {
        color: "white",
    },
    descriptionSuccessBox: {
        mt: [5, 5],
    },
    descriptionSuccessFadeBox: {
        color: "white",
    },
} satisfies Record<string, StyleProps>;
